//@ts-nocheck
import {Image as FastImage} from 'react-native';

export const FastImageProps = {} as const;
FastImage.priority = {
  normal: 'normal',
};
FastImage.preload = () => {};

export default FastImage;
